module.exports = __webpack_public_path__ + "static/media/h2.d6874459.svg";